/**
 * The validators `connectorRegistry` registers in the connector hub (FR-41), read from
 * `skypoint-connector-hub/src/connectors/registry.ts`.
 *
 * The hub is a different repository, so the list is restated here; a connector whose validator
 * is added there is added here with it. The hub routes `POST /api/connectors/:key/validate`
 * through that registry, so a seed naming a key it does not hold gets a 404 and no connection
 * can leave `draft`. `validateSeed` refuses such a seed for an active connector and warns for an
 * inactive one, at every door: the upload route, the upload dialog, the seed CLI and the catalog
 * test (A13). It moved here from `scripts/__tests__/seedConnectors.catalog.test.ts`, which used to
 * be the only place that knew it.
 */
export const CONNECTOR_HUB_VALIDATORS: readonly string[] = [
  "acumatica",
  "aline-ops",
  "aod",
  "august-health",
  "fmx",
  "foresite",
  "frontline",
  "ga4",
  "geotab",
  "gsc",
  "mouseflow",
  "mysql",
  "nestwelcome",
  "ninety",
  "paychex",
  "paycom",
  "paylocity",
  "pcc",
  "peopleforce",
  "relias",
  "sftp",
  "sitelligence",
  "sogolytics",
  "sqlserver",
  "ukg-pro-hcm",
  "ukgwfm",
  "worksphere",
];
